export const K2_REPORT = `K2_REPORT`;

/* LAYOUT */
export const GET_K2_REPORT_DATETIME_DATA = `${K2_REPORT}/GET_K2_REPORT_DATETIME_DATA`;
export const SET_K2_REPORT_DATETIME_DATA = `${K2_REPORT}/SET_K2_REPORT_DATETIME_DATA`;

export const CHECK_AGENT_IS_LEAF_NODE = `${K2_REPORT}/CHECK_AGENT_IS_LEAF_NODE`;

export const GET_K2_REPORT_INDIVIDUAL_DATA = `${K2_REPORT}/GET_K2_REPORT_INDIVIDUAL_DATA`;
export const GET_K2_REPORT_GROUP_DATA = `${K2_REPORT}/GET_K2_REPORT_GROUP_DATA`;
export const SET_K2_REPORT_TABLE_DATA = `${K2_REPORT}/SET_K2_REPORT_TABLE_DATA`;

export const GET_K2_REPORT_SUMMARY_DATA = `${K2_REPORT}/GET_K2_REPORT_SUMMARY_DATA`;
export const SET_K2_REPORT_SUMMARY_DATA = `${K2_REPORT}/SET_K2_REPORT_SUMMARY_DATA`;

export const SET_K2_REPORT_BREADCRUMB_DATA = `${K2_REPORT}/SET_K2_REPORT_BREADCRUMB_DATA`;
export const SET_K2_REPORT_SELECTED_BREADCRUMB_DATA = `${K2_REPORT}/SET_K2_REPORT_SELECTED_BREADCRUMB_DATA`;

export const SET_K2_REPORT_SELECTED_TAB_DATA = `${K2_REPORT}/SET_K2_REPORT_SELECTED_TAB_DATA`;

export const SET_K2_REPORT_FILTER = `${K2_REPORT}/SET_K2_REPORT_FILTER`;

export const GET_POLICY_DATA = `${K2_REPORT}/GET_POLICY_DATA`;
export const SET_POLICY_DATA = `${K2_REPORT}/SET_POLICY_DATA`;
export const RESET_POLICY_DATA = `${K2_REPORT}/RESET_POLICY_DATA`;
export const GET_POLICY_DETAIL_DATA = `${K2_REPORT}/GET_POLICY_DETAIL_DATA`;
export const SET_POLICY_DETAIL_DATA = `${K2_REPORT}/SET_POLICY_DETAIL_DATA`;
export const GET_TEAM_POLICY_DATA = `${K2_REPORT}/GET_TEAM_POLICY_DATA`;
export const SET_TEAM_POLICY_DATA = `${K2_REPORT}/SET_TEAM_POLICY_DATA`;

export const RESET_STATE = 'RESET_STATE';

export const FETCH_POLICY_LIST_START = `${K2_REPORT}/FETCH_POLICY_LIST_START`;
export const FETCH_POLICY_LIST_SUCCESS = `${K2_REPORT}/FETCH_POLICY_LIST_SUCCESS`;
